module.exports = "https://static.zego.com/_next/static/images/ThirtyDaysPrivateHire-f24255dc58e2aba4c661639ebf1deb3f.svg";